import pageStateMixin from "./pageStateMixin";

// 全局可用事件 如果属性或方法同名 父级优先
export default {
  mixins: [pageStateMixin],
  data() {
    return {
      // 验证码态 false:发送验证码 true:获取并倒计时
      showTime: false,
      // 倒计时剩余秒数
      count: "",
      //开启倒计时开关
      timer: null,
    };
  },
  methods: {
    // 登录 注册 清空错误提示
    clearTips() {
      this.usernameError = "";
      this.passwordError = "";
      this.loginError = "";
    },
    //清空已填数据
    clearForm(obj) {
      for (let i in obj) {
        this.$set(obj, i, "");
      }
      return obj;
    },

    // 格式化日期
    formateTime(time, formate = "yyyy-MM-dd") {
      if (!time) {
        return "-";
      }

      let date = new Date(time * 1000);
      let year = date.getFullYear();
      let month = date.getMonth() + 1;
      let day = date.getDate();
      let hour = date.getHours();
      let minute = date.getMinutes();
      let second = date.getSeconds();
      return formate
      .replace("yyyy", year)
      .replace("MM", this.formatNumber(month))
      .replace("dd", this.formatNumber(day))
      .replace("HH", this.formatNumber(hour))
      .replace("mm", this.formatNumber(minute))
      .replace("ss", this.formatNumber(second))
    },

    formatNumber(n) {
      let s = n.toString();
      return s[1] ? s : "0" + s;
    },

    // 获取课程类型
    courseType(type) {
      if (type == 1) {
        return "小班课";
      } else if (type == 2) {
        return "私教课";
      } else if (type == 4) {
        return "通用课时";
      } else if (type == 8) {
        return "集训课时";
      }
    },
    // 获取日期的周几
    weekday(time) {
      let date = new Date(time * 1000);
      let weekdayArray = [
        "周日",
        "周一",
        "周二",
        "周三",
        "周四",
        "周五",
        "周六",
      ];
      let weakday = weekdayArray[date.getDay()];
      return weakday;
    },
    // 获取日期的日
    day(time) {
      let date = new Date(time * 1000);
      return date.getDate();
    },
    // 获取时间段
    slot(timeSlot) {
      let hour = parseInt(timeSlot);
      return (
        (hour < 10 ? "0" + hour : hour) +
        ":00~" +
        (hour + 1 < 10 ? "0" + (hour + 1) : hour + 1) +
        ":00"
      );
    },
  },
};
